import React from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

import {RoutineRunAs, tagFileBlocksWithCopySource} from './RoutineTypes';
import {RoutineFormState} from './useRoutineForm';

export const COPY_AGENT_CHAT_SETTINGS_EXAMPLE_ID = 'copy-agent';

export function copyAgentDisplayName(sourceName: string): string {
  return `${sourceName} (copy)`;
}

export function copyAgentExampleId(sourceRoutineId: string): string {
  return `copy-${sourceRoutineId}`;
}

export function buildCopyAgentFormState(
  formState: RoutineFormState,
  sourceRoutineId: string
): RoutineFormState {
  return {
    ...formState,
    name: copyAgentDisplayName(formState.name),
    fileBlocks: tagFileBlocksWithCopySource(formState.fileBlocks, sourceRoutineId),
  };
}

export function CopyAgentCreateBanner({
  sourceName,
  runAs,
}: {
  sourceName: string;
  runAs: RoutineRunAs;
}): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      text={
        <>
          Creating a new agent from <em>{sourceName}</em>
        </>
      }
      supportingInfo={
        <>
          This will be a separate agent{' '}
          {runAs === RoutineRunAs.SERVICE_ACCOUNT ? 'with its own identity' : ''} — changes here won’t affect
          the original.
        </>
      }
    />
  );
}
